import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes} from '@angular/router';
import {UserRouteAccessService} from '../../shared';
import {PaginationUtil} from 'ng-jhipster';
import {HistoriqueComponent} from './historique.component';
import {HistoriqueDetailComponent} from './historique-detail.component';
import {HistoriquePopupComponent} from './historique-dialog.component';
import {HistoriqueDeletePopupComponent} from './historique-delete-dialog.component';

@Injectable()
export class HistoriqueResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const historiqueRoute: Routes = [
    {
        path: 'historique',
        component: HistoriqueComponent,
        resolve: {
            'pagingParams': HistoriqueResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        canActivate: [UserRouteAccessService]
    }, {
        path: 'historique/candidatureFormation/:candidatureFormationId',
        component: HistoriqueComponent,
        resolve: {
            'pagingParams': HistoriqueResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        canActivate: [UserRouteAccessService]
    }
    , {
        path: 'historique/:id',
        component: HistoriqueDetailComponent,
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const historiquePopupRoute: Routes = [
    {
        path: 'historique-new',
        component: HistoriquePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'historique/:id/edit',
        component: HistoriquePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'historique/:id/delete',
        component: HistoriqueDeletePopupComponent,
        data: {
            authorities: ['ROLE_SYSTEM'],
            pageTitle: 'cadensApp.historique.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique.route.ts